/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OWGameResponse,
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChallengeInstantReward
 */
export interface ChallengeInstantReward {
    /**
     * 
     * @type {string}
     * @memberof ChallengeInstantReward
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInstantReward
     */
    questName: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInstantReward
     */
    questDescription: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeInstantReward
     */
    isCompleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeInstantReward
     */
    isClaimed: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChallengeInstantReward
     */
    target: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeInstantReward
     */
    progress: number;
    /**
     * 
     * @type {Array<OWGameResponse>}
     * @memberof ChallengeInstantReward
     */
    games: Array<OWGameResponse>;
}

export function ChallengeInstantRewardFromJSON(json: any): ChallengeInstantReward {
    return ChallengeInstantRewardFromJSONTyped(json, false);
}

export function ChallengeInstantRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeInstantReward {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'questName': json['questName'],
        'questDescription': json['questDescription'],
        'isCompleted': json['isCompleted'],
        'isClaimed': json['isClaimed'],
        'target': json['target'],
        'progress': json['progress'],
        'games': ((json['games'] as Array<any>).map(OWGameResponseFromJSON)),
    };
}

export function ChallengeInstantRewardToJSON(value?: ChallengeInstantReward | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'questName': value.questName,
        'questDescription': value.questDescription,
        'isCompleted': value.isCompleted,
        'isClaimed': value.isClaimed,
        'target': value.target,
        'progress': value.progress,
        'games': ((value.games as Array<any>).map(OWGameResponseToJSON)),
    };
}


